import { render, staticRenderFns } from "./FolhasObraMainList.vue?vue&type=template&id=8dabe7b6&scoped=true&"
import script from "./FolhasObraMainList.vue?vue&type=script&lang=js&"
export * from "./FolhasObraMainList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dabe7b6",
  null
  
)

export default component.exports